export const projectName = 'CSM Shopfloor'
export const projectVersion = '1.0.6'